module.exports = __webpack_public_path__ + "img/import-icon.a833c91e.svg";